import { useEffect, useState } from 'react';
import { useQuizAssessmentAvailabilityDataProvider } from '../../../../providers/data-provider/quiz-assessment-availability.data.provider';

// No endpoint aggregates correction progress across printed assessments, so this fetches
// each assessment's student result items (same endpoint the results page already uses)
// and derives corrected/pending counts and grades from the per-student `status` field.
export function usePrintedAssessmentCorrections(records) {
  const { listAvailabilityResultItem } = useQuizAssessmentAvailabilityDataProvider();
  const [correctionByAvailability, setCorrectionByAvailability] = useState({});

  useEffect(() => {
    records
      .filter((record) => !correctionByAvailability[record.id])
      .forEach((record) => {
        listAvailabilityResultItem(record.id).then((res) => {
          const studentResults = res.data || [];
          const correctedResults = studentResults.filter((student) => student.status === 'finished');
          setCorrectionByAvailability((prev) => ({
            ...prev,
            [record.id]: {
              correctedCount: correctedResults.length,
              totalCount: studentResults.length,
              correctedResults,
            },
          }));
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [records]);

  return correctionByAvailability;
}